var _defs, _path, _rect, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 269 269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d9d9d9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cara de muertito") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M907.26,1150.28h-105a82,82,0,0,0-82,82v105a82,82,0,0,0,82,82h105a82,82,0,0,0,82-82v-105A82,82,0,0,0,907.26,1150.28Zm55.23,188.22a54,54,0,0,1-54,54H801.07a54,54,0,0,1-54-54V1231.07a54,54,0,0,1,54-54H908.5a54,54,0,0,1,54,54Z",
    transform: "translate(-720.28 -1150.28)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67,
    y: 180.02,
    width: 135,
    height: 27,
    rx: 13.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M826.84,1265.67l5.23-5.24A13.5,13.5,0,1,0,813,1241.34l-5.23,5.23-5.24-5.23a13.5,13.5,0,1,0-19.09,19.09l5.23,5.24-5.23,5.23a13.48,13.48,0,0,0,0,19.09h0a13.48,13.48,0,0,0,19.09,0l5.24-5.23L813,1290a13.48,13.48,0,0,0,19.09,0h0a13.48,13.48,0,0,0,0-19.09Z",
    transform: "translate(-720.28 -1150.28)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M920.91,1265.67l5.24-5.24a13.5,13.5,0,1,0-19.09-19.09l-5.24,5.23-5.24-5.23a13.5,13.5,0,0,0-19.09,19.09l5.24,5.24-5.24,5.23a13.5,13.5,0,0,0,0,19.09h0a13.48,13.48,0,0,0,19.09,0l5.24-5.23,5.24,5.23a13.48,13.48,0,0,0,19.09,0h0a13.5,13.5,0,0,0,0-19.09Z",
    transform: "translate(-720.28 -1150.28)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.adb7c2aa18430e2340451eab497db1e3.svg";
export { ForwardRef as ReactComponent };